<template>
<div
  class="bbp-user-container"
  :class="{'bbp-user-container_disabled': input.disabled}"

>
  <div class="bbp-user-container__title">Users</div>
  <div class="bbp-user-container-body"
       v-for="helpUser in helpUsers"
       :key="helpUser.user.id"
  >
    <img :src="getUserImage(helpUser.user)"
         class="bbp-user-container-list-user__image"
         @click.stop="removeHelpUser(helpUser)"
         v-if="helpUser.user.image"/>
    <i class="bbp-icon-user bbp-user-container-list-user__image"
       @click.stop="removeHelpUser(helpUser)"
       v-else/>
    <span class="bbp-user-container__text">{{helpUser.user.username}}</span>
    <div class="bbp-error-text bbp-user-container__error">{{helpUser.error}}</div>
    <div class="bbp-user-container-percent">
      <input type="text"
             :disabled="input.disabled"
             v-autofocus="!!input.autofocus"
             :class="{'bbp-input_error': helpUser.error}"
             v-model="helpUser.percent"
             @input="handlerInputPercent($event, helpUser)"
             class="bbp-input bbp-user-container-percent__input">
      <span class="bbp-user-container-percent__icon">%</span>
    </div>
  </div>
  <div class="bbp-user-container-footer"
       :class="{'bbp-user-container-footer_disabled': input.disabled}"
       @click.stop="openSelectUser"
       @keyup.esc="closeList"
  >
    <i class="bbp-icon-plus bbp-user-container-footer__icon"/>
    <span class="bbp-user-container-footer__text">Add new user</span>
    <transition name="bbp-slide-select">
      <div class="bbp-user-container-footer__wrapper"
           :style="popupPosition"
           v-if="openList"
      >
        <VuePerfectScrollbar :settings="scrollSettings"
                             @click.stop
                             class="bbp-user-container-list"
        >
          <div class="bbp-user-container-list__margin bbp-user-container-list__margin_top"/>
          <div class="bbp-user-container-list-user"
               @click.stop="setUser(user)"
               v-for="user in usersList"
               :key="user._id"
          >
            <img class="bbp-user-container-list-user__image"
                 :src="getUserImage(user)"
                 v-if="user.image"/>
            <i class="bbp-icon-user bbp-user-container-list-user__image" v-else/>
            <span class="bbp-user-container-list-user__username">{{user.username}}</span>
          </div>
          <div class="bbp-user-container-list__margin bbp-user-container-list__margin_bottom"/>
        </VuePerfectScrollbar>
      </div>
    </transition>
  </div>
</div>
</template>

<script>
import UserApi from '@/api/Users/api'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {get, set, filter, round, compact, uniqBy, groupBy, orderBy} from 'lodash'
export default {
  name: 'BBPUserContainer',
  props: ['input', 'model', 'errorText'],
  components: {VuePerfectScrollbar},
  computed: {
    usersListProjects: {
      get () {
        return this.$store.getters.usersListProjects
      },
      set (data) {
        this.$store.dispatch('setUsersListProjects', data)
      }
    },
    usersList () {
      const filteredUsers = filter(this.usersListProjects, user => {
        const { position = [] } = user
        const projectManager = this.model.projectManager.id
        const businessConsultant = this.model.businessConsultant.id
        return position.length && user._id !== projectManager && user._id !== businessConsultant
      })

      const groupUsers = groupBy(filteredUsers, 'isNotAssigned')
      const isNotAssigned = groupUsers.true || []
      const usersSorted = orderBy(groupUsers.false, [item => item.username.toLowerCase()], ['asc'])
      return compact(uniqBy([...usersSorted, ...isNotAssigned], '_id'))
    },
    countAddedUsers () {
      return this.helpUsers.length - this.limitCount - 1
    },
    addedUsers () {
      return this.helpUsers.slice(this.limitCount + 1)
    }
  },
  data () {
    return {
      openList: false,
      showPopup: false,
      popupPosition: {},
      helpUsers: [],
      usersLimit: 9999,
      limitCount: 1,
      value: '',
      error: '',
      scrollSettings: { wheelPropagation: false, minScrollbarLength: 25 }
    }
  },
  methods: {
    openSelectUser (e) {
      this.openList = !this.openList
      if (!this.openList) return
      this.setDisplayPopup(e, this.openList)
      this.getUsersListSelect()
    },
    openAddedUsers () {
      this.showPopup = !this.showPopup
    },
    closeList () {
      this.openList = false
    },
    async getUsersListSelect () {
      if (this.usersListProjects.length) return
      try {
        const { data } = await UserApi.getUsersListSelect({})
        this.usersListProjects = data
      } catch (err) {
        console.error(err)
      }
    },
    handlerInputPercent ({target}, helpUser) {
      const result = this.validateNumber(target.value)
      this.addUserInKPI(result, helpUser)
    },
    addUserInKPI (result, helpUser) {
      helpUser.percent = result !== 0 ? result : ''
      const totalPercent = this.helpUsers.reduce((sum, item) => {
        return sum + (item.user._id !== helpUser.user._id ? +item.percent : 0)
      }, 0)
      const maxPercent = 100 - totalPercent
      if (result > maxPercent) {
        helpUser.percent = maxPercent
      }
      set(this.model, this.input.model, this.helpUsers)
    },
    validateNumber (value) {
      const result = this.toNumSave(value, true)
      if (isNaN(+result)) {
        this.$emit('error', 'enter the number')
        this.error = 'enter the number'
        return ''
      } else {
        this.$emit('error', false)
        this.error = ''
      }
      return round(+result, 2)
    },
    toNumSave (value, num) {
      const regexNum = /[0-9]+|\./gmi
      const regexInput = /[0-9]+|,+|\.+/gmi
      const regex = num ? regexNum : regexInput
      if (typeof value === 'string') {
        const match = value.match(regex) || []
        return match.join('')
      }
    },
    removeHelpUser (helpUser) {
      const userIndex = this.helpUsers.findIndex(item => item.user._id === helpUser.user._id)
      if (userIndex !== -1) {
        this.helpUsers.splice(userIndex, 1)
        this.usersList.push(helpUser.user)
        set(this.model, this.input.model, this.helpUsers)
      }
    },
    setUser (user) {
      const userIndex = this.helpUsers.findIndex(item => item.user._id === user._id)
      if (userIndex === -1) {
        this.helpUsers.push({
          user,
          percent: 1,
          temp: true
        })
        const index = this.usersList.findIndex(item => item._id === user._id)
        this.usersList.splice(index, 1)
        this.addUserInKPI(1, {
          user,
          percent: 1,
          temp: true
        })
      }
      this.closeList()
    },
    setDefaultVal () {
      const value = get(this.model, this.input.model, [])
      if (value) {
        this.helpUsers = value.filter(item => !item.temp)
      }
    },
    getUserImage (user) {
      return get(user, 'image.path', '')
    },
    setDisplayPopup (e, val) {
      const position = e.target.getBoundingClientRect()
      if (val && position) {
        this.popupPosition = {
          position: 'fixed',
          top: position.top + position.height + 4 + 'px',
          left: 'auto'
        }
      } else {
        this.popupPosition = {}
      }
    }
  },
  watch: {
    errorText () {
      if (this.errorText) {
        this.helpUsers.forEach(item => {
          const error = !item.percent ? this.errorText : ''
          this.$set(item, 'error', error)
        })
      }
    }
  },
  beforeMount () {
    this.setDefaultVal()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";
  .bbp-user-container {
    position: relative;

    &_disabled {
      pointer-events: none;
    }

    &__text {
      font-size: 14px;
      line-height: 17px;
      font-style: normal;
      font-weight: normal;
      text-transform: capitalize;
    }

    &__error {
      position: static;
    }

    &-percent {
      display: flex;
      justify-content: space-around;
      align-items: center;

      &__input {
        padding: 8px 11px;
        font-weight: 300;
        font-size: 12px;
        line-height: 14px;
        width: 44px;
        text-align: center;
        height: 30px;
      }

      &__icon {
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        color: $color-silver;
      }
    }

    &-list {
      overflow: hidden;
      max-height: 144px;
      padding: 0 8px;

      &-user {
        display: grid;
        grid-template-columns: 28px auto;
        grid-gap: 8px;
        align-items: center;
        margin-bottom: 8px;
        font-size: 13px;
        line-height: 16px;
        text-transform: capitalize;
        transition: 0.3s;
        cursor: pointer;

        &:hover {
          color: $color-accent;
        }

        &__image {
          width: 28px;
          height: 28px;
          color: $color-accent;
          object-fit: cover;
          font-size: 28px;
          border-radius: 50%;
          cursor: pointer;
          transition: 0.3s;

          &:hover {
            opacity: 0.5;
          }

          &:before {
            margin: 0;
          }
        }
      }

      &__margin {
        position: sticky;
        background-color: $color-white;
        height: 10px;
        width: 100%;
        z-index: 2;

        &_top {
          top: 0;
        }

        &_bottom {
          bottom: 0
        }
      }
    }

    &__title {
      font-style: normal;
      font-weight: 600;
      font-size: 13px;
      line-height: 16px;
      color: $color-denim;
    }

    &-block {
      position: relative;
      font-weight: 500;
      font-size: 12px;
      min-width: 80px;
      height: 14px;
      color: $color-denim;
      line-height: 14px;
      padding-top: 10px;
      padding-bottom: 16px;
      cursor: pointer;

      &__popup {
        position: absolute;
        top: 34px;
        left: 1px;
        width: auto;
        min-width: 170px;
        background-color: $color-white;
        box-shadow: 0 0 12px rgba($color-black, 0.12);
        border-radius: 5px;
        z-index: 3;

        &:before {
          content: '';
          position: absolute;
          left: 8px;
          top: -5px;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 0 5px 5px 5px;
          border-color: transparent transparent $color-white transparent;
        }
      }
    }

    &-body {
      display: grid;
      grid-template-columns: 29px 1fr 90px 70px;
      grid-gap: 8px;
      padding-top: 8px;
      padding-bottom: 10px;
      align-items: center;

      &_popup {
        grid-template-columns: 37px 322px 70px;
      }
    }

    &-footer {
      display: flex;
      align-items: center;
      cursor: pointer;
      position: relative;
      padding-top: 20px;

      &__icon {
        color: $color-denim;
        font-size: 10px;
      }

      &__text {
        font-style: normal;
        font-weight: 600;
        padding-left: 8px;
        font-size: 13px;
        line-height: 16px;
        color: $color-denim;
        transition: 0.3s;

        &:hover {
          opacity: 0.8;
        }
      }

      &_disabled {
        .bbp-user-container-footer__icon,
        .bbp-user-container-footer__text {
          color: $color-silver;
        }

      }

      &__wrapper {
        position: absolute;
        top: 34px;
        left: 1px;
        width: auto;
        min-width: 170px;
        background-color: $color-white;
        box-shadow: 0 0 12px rgba($color-black, 0.12);
        border-radius: 5px;
        z-index: 3;

        &:before {
          content: '';
          position: absolute;
          left: 8px;
          top: -5px;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 0 5px 5px 5px;
          border-color: transparent transparent $color-white transparent;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPForm/BBPUserContainer/BBPUserContainer.vue